<template lang="html">
  <div class="result-head">
    <img v-if="type === 'success'" src="../../assets/images/result-icon-success-2.png" alt="" class="result-head-icon">
    <img v-if="type === 'warn'" src="../../assets/images/result-icon-warn.png" alt="" class="result-head-icon">
    <p>
      <slot></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ResultHead',

  props: ['type']
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.result-head {
  text-align: center;
  font-size: use(30);
  color: #333333;
  font-weight: bolder;
  padding: rem(72) 0 rem(58) 0;
  line-height: 1.4;
  &-icon {
    display: inline-block;
    width: rem(65);
    margin-bottom: rem(10);
  }
}
</style>
